// Datas e links da consulta. A API manda `starts_at` com o deslocamento do fuso
// (2026-10-20T14:00:00-03:00) e os dias dos horários livres como AAAA-MM-DD.

const LOCALE = 'pt-BR';

/** "Terça-feira, 20 de outubro às 14:00" */
export function formatWhen(iso) {
    const date = new Date(iso);

    const day = new Intl.DateTimeFormat(LOCALE, { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
    const time = new Intl.DateTimeFormat(LOCALE, { hour: '2-digit', minute: '2-digit' }).format(date);

    return `${day.charAt(0).toUpperCase()}${day.slice(1)} às ${time}`;
}

/** Um dia AAAA-MM-DD como data local (sem o deslocamento de fuso do `new Date('AAAA-MM-DD')`). */
export function parseDay(day) {
    const [year, month, date] = day.split('-').map(Number);

    return new Date(year, month - 1, date);
}

/** { weekday: 'ter', day: '20', month: 'out' } para o botão do dia. */
export function dayParts(day) {
    const date = parseDay(day);

    return {
        weekday: new Intl.DateTimeFormat(LOCALE, { weekday: 'short' }).format(date).replace('.', ''),
        day: String(date.getDate()),
        month: new Intl.DateTimeFormat(LOCALE, { month: 'short' }).format(date).replace('.', ''),
    };
}

/** "ter, 20/10" */
export function shortDay(day) {
    const [, month, date] = day.split('-');

    return `${dayParts(day).weekday}, ${date}/${month}`;
}

/** "terça-feira, 20 de outubro" */
export function formatDay(day) {
    return new Intl.DateTimeFormat(LOCALE, { weekday: 'long', day: 'numeric', month: 'long' }).format(parseDay(day));
}

function toCalendarUtc(iso) {
    return new Date(iso).toISOString().replace(/[-:]|\.\d{3}/g, '');
}

/** Link do Google Agenda já com o evento preenchido. */
export function googleCalendarUrl(booking) {
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: `Consulta grátis Whizr com ${booking.consultant.name}`,
        dates: `${toCalendarUtc(booking.starts_at)}/${toCalendarUtc(booking.ends_at)}`,
        details: [
            booking.topic_label && `Assunto: ${booking.topic_label}`,
            booking.meeting_url && `Reunião: ${booking.meeting_url}`,
        ].filter(Boolean).join('\n'),
    });

    if (booking.meeting_url) {
        params.set('location', booking.meeting_url);
    }

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function initials(name) {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0].toUpperCase())
        .join('');
}
